import { animationTransition } from '@shared/utils/animationTransition';
import type { FlexProps, BoxProps } from '@withjoy/joykit';
import { Box } from '@withjoy/joykit';
import type { KeyboardEvent } from 'react';
import React from 'react';
import { HeaderLinksContainer, styles } from './HeaderLinksGroupButton.styles';

const ChevronArrow = (props: BoxProps) => {
  return (
    <Box
      as="svg"
      width="16px"
      height="16px"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M18.253 8.801a.6.6 0 010 .849L13.13 14.77a1.6 1.6 0 01-2.263 0L5.75 9.651a.6.6 0 11.849-.848l5.119 5.12a.4.4 0 00.566 0L17.404 8.8a.6.6 0 01.849 0z"
        fill="currentColor"
      />
    </Box>
  );
};

interface HeaderLinksGroupButtonProps extends FlexProps {
  isActive: boolean;
  onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => void;
}

export const HeaderLinksGroupButton = ({ children, isActive, ...restProps }: React.HtmlHTMLAttributes<HTMLElement> & HeaderLinksGroupButtonProps) => {
  return (
    <HeaderLinksContainer
      tabIndex={0}
      __css={styles.headerLinksContainer(isActive)}
      {...restProps}
      style={{ fontSynthesis: 'none' }}
    >
      {children}{' '}
      <ChevronArrow
        marginLeft="4px"
        transition={animationTransition('transform', 'color')}
        transform={isActive ? 'rotate(-180deg)' : 'rotate(0deg)'}
      />
    </HeaderLinksContainer>
  );
};
